import React, { useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Grid, Header, Segment, Table, Button, Icon } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { useTranslation } from 'react-i18next'
import { CoolFarmOptionsContext } from '../..'

const Transport: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'transportTypes',
    keyName: 'key'
  })

  const transportTypeOptions = options?.transportTypes?.map(type => ({
    key: type.id,
    value: type.id,
    text: type.label
  })) || []

  const weightUnitOptions = options?.transportWeightUnits?.map(unit => ({
    key: unit.key,
    value: unit.key,
    text: unit.label
  })) || []

  return (
    <>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t('Transport Type')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Weight')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Weight Unit')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Distance (in km)')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {fields.map((field, index) => (
            <Table.Row key={field.key}>
              <Table.Cell>
                <FormFields.Select
                  control={control}
                  name={`transportTypes[${index}].id`}
                  withoutAsterisk
                  options={transportTypeOptions}
                  placeholder={t('Select transport type')}
                  noErrorMessage
                      />
              </Table.Cell>
              <Table.Cell>
                <FormFields.Input
                  control={control}
                  name={`transportTypes[${index}].weight`}
                  withoutAsterisk
                  placeholder={t('Enter weight')}
                  typeInput='controled'
                  noErrorMessage
                      />
              </Table.Cell>
              <Table.Cell>
                <FormFields.Select
                  control={control}
                  name={`transportTypes[${index}].weightUnit`}
                  withoutAsterisk
                  options={weightUnitOptions}
                  placeholder={t('Select unit')}
                  noErrorMessage
                      />
              </Table.Cell>
              <Table.Cell>
                <FormFields.Input
                  control={control}
                  name={`transportTypes[${index}].distance`}
                  withoutAsterisk
                  placeholder={t('in km')}
                  typeInput='controled'
                  noErrorMessage
                      />
              </Table.Cell>
              <Table.Cell >
                <Icon
                  name='trash'
                  color='red'
                  style={{ cursor: 'pointer' }}
                  onClick={() => remove(index)}
                      />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
        <Button
          type='button'
          icon='plus'
          style={{ color: 'white' }}
          content={t('Add Transport')}
          onClick={() => append({
            id: null,
            weight: null,
            weightUnit: null,
            distance: null
          })}
              />
      </div>
    </>
  )
}

export default Transport
